<template>
  <div
    :class="[
      'mod-icon',
      `set-${mod.set}`,
      `tier-${mod.tier}`,
      `slot-${mod.slot}`,
      `mk-${mod.pips}`,
      size,
    ]"
  >
    <div v-if="showSlot" class="mod-slot"></div>
    <div v-if="showSet && mod.set" class="mod-set"></div>
    <img v-if="showToon && mod.toon && imageUrl" :src="imageUrl" />
  </div>
</template>
<script>
import { imageUrlForCharacter } from "/@/utils";

export default {
  name: "Icon",
  props: {
    mod: Object,
    showSet: {
      type: Boolean,
      default: true,
    },
    showSlot: {
      type: Boolean,
      default: true,
    },
    showToon: {
      type: Boolean,
      default: true,
    },
    size: String,
  },
  computed: {
    imageUrl() {
      return imageUrlForCharacter(this.mod.toon);
    },
  },
};
</script>

<style lang="scss" scoped>
$scale: 1.3;
$icon-size: $scale * 90px;
$set-size: $scale * 32px;
$toon-size: $scale * 35px;
$small: 0.2;
$small-icon-size: $icon-size * $small;
$small-set-size: $set-size * $small;
$small-toon-size: $toon-size * $small;
$medium: 0.7;
$medium-icon-size: $icon-size * $medium;
$medium-set-size: $set-size * $medium;
$medium-toon-size: $toon-size * $medium;

.mod-icon {
  position: relative;
  width: $icon-size;
  height: $icon-size;
  display: inline-block;
}

.mod-slot {
  width: $icon-size;
  height: $icon-size;
  background-image: url(https://swgoh.gg/static/img/ui/mod-shape-atlas.png);
  background-size: 1200% 500%;
}

.small {
  &.mod-icon {
    width: $small-icon-size;
    height: $small-icon-size;
  }
  & .mod-slot {
    width: $small-icon-size;
    height: $small-icon-size;
    background-size: 1200% 500%;
  }
  & .mod-set {
    width: $small-set-size;
    height: $small-set-size;
  }
  &.slot-undefined .mod-set {
    width: $small-icon-size;
    height: $small-icon-size;
  }
}

.medium {
  &.mod-icon {
    width: $medium-icon-size;
    height: $medium-icon-size;
  }
  & .mod-slot {
    width: $medium-icon-size;
    height: $medium-icon-size;
    background-size: 1200% 500%;
  }
  & .mod-set {
    width: $medium-set-size;
    height: $medium-set-size;
  }
  &.slot-undefined .mod-set {
    width: $medium-icon-size;
    height: $medium-icon-size;
  }
}

.mod-set {
  position: absolute;
  background-image: url(https://swgoh.gg/static/img/ui/mod-icon-atlas.png);
  background-size: 800% 500%;
  width: $set-size;
  height: $set-size;
}

@for $i from 2 through 5 {
  .tier-#{$i} .mod-slot {
    background-position-y: #{($i - 1) * -1 * $icon-size};
  }
  .tier-#{$i} .mod-set {
    background-position-y: #{($i - 1) * -1 * $set-size};
  }
  .small.tier-#{$i} .mod-slot {
    background-position-y: #{($i - 1) * -1 * $small-icon-size};
  }
  .small.tier-#{$i} .mod-set {
    background-position-y: #{($i - 1) * -1 * $small-set-size};
  }
  .medium.tier-#{$i} .mod-slot {
    background-position-y: #{($i - 1) * -1 * $medium-icon-size};
  }
  .medium.tier-#{$i} .mod-set {
    background-position-y: #{($i - 1) * -1 * $medium-set-size};
  }
}

.mk-6.slot-0 .mod-slot {
  background-position-x: #{6 * -1 * $icon-size};
}
.small.mk-6.slot-0 .mod-slot {
  background-position-x: #{6 * -1 * $small-icon-size};
}
.medium.mk-6.slot-0 .mod-slot {
  background-position-x: #{6 * -1 * $medium-icon-size};
}
@for $i from 1 through 5 {
  .slot-#{$i} .mod-slot {
    background-position-x: #{$i * -1 * $icon-size};
  }
  .small.slot-#{$i} .mod-slot {
    background-position-x: #{$i * -1 * $small-icon-size};
  }
  .medium.slot-#{$i} .mod-slot {
    background-position-x: #{$i * -1 * $medium-icon-size};
  }
  .mk-6.slot-#{$i} .mod-slot {
    background-position-x: #{($i + 6) * -1 * $icon-size};
  }
  .small.mk-6.slot-#{$i} .mod-slot {
    background-position-x: #{($i + 6) * -1 * $small-icon-size};
  }
  .medium.mk-6.slot-#{$i} .mod-slot {
    background-position-x: #{($i + 6) * -1 * $medium-icon-size};
  }
}

@for $i from 1 through 8 {
  .set-#{$i} .mod-set {
    background-position-x: #{($i - 1) * -1 * $set-size};
  }
  .small.set-#{$i} .mod-set {
    background-position-x: #{($i - 1) * -1 * $small-set-size};
  }
  .medium.set-#{$i} .mod-set {
    background-position-x: #{($i - 1) * -1 * $medium-set-size};
  }
  .small.slot-undefined.set-#{$i} .mod-set {
    background-position-x: #{($i - 1) * -1 * $small-icon-size};
  }
  .medium.slot-undefined.set-#{$i} .mod-set {
    background-position-x: #{($i - 1) * -1 * $medium-icon-size};
  }
}

.slot-0 .mod-set {
  top: 24%;
  left: 41%;
}

.slot-1 .mod-set {
  top: 19%;
  left: 44%;
  transform: scale(0.8);
}

.slot-2 .mod-set {
  top: 32%;
  left: 32%;
  transform: scale(0.9);
}

.slot-3 .mod-set {
  top: 40%;
  left: 32%;
  transform: scale(0.7);
}

.slot-4 .mod-set {
  top: 33%;
  left: 33%;
  transform: scale(0.8);
}

.slot-5 .mod-set {
  top: 34%;
  left: 32%;
  transform: scale(0.85);
}

.mod-icon img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: $toon-size;
  height: $toon-size;
  border-radius: 50%;
  border: 3px solid lightgrey;
}

.small.mod-icon img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: $small-toon-size;
  height: $small-toon-size;
  border-radius: 50%;
  border: 3px solid lightgrey;
}

.medium.mod-icon img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: $medium-toon-size;
  height: $medium-toon-size;
  border-radius: 50%;
  border: 3px solid lightgrey;
}
</style>
